import { GeneralConditionsProvider } from '@/features/general-conditions/services/general-conditions.service';
import { ChangeDetectionStrategy, Component, inject, resource } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { Temporal } from 'temporal-polyfill';
import { BrandingProvider } from '../../providers/branding/branding.provider';

@Component({
    selector: 'advizeo-footer',
    templateUrl: './advizeo-footer.component.html',
    styleUrls: ['./advizeo-footer.component.scss'],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvizeoFooterComponent {
    private _generalConditionsProvider = inject(GeneralConditionsProvider);
    private _brandingProvider = inject(BrandingProvider);

    isNotCustomBranding = toSignal(this._brandingProvider.isNotCustomBranding$());

    legalDocumentsFiles = resource({
        loader: () => {
            return this._generalConditionsProvider.getLegalDocumentFiles();
        }
    });
    protected readonly Temporal = Temporal;
}
